import { ApiEvent } from '@api/model/api-event';
import { CardConfig } from '@model/card-config';
import { Event } from '@model/event';
import { EventAction } from '@model/event-action';

import {
  getEventSettingValue,
  isEventSettingTrue,
} from './api-event-setting.util';

/**
 * Converts an API event response to the internal Event model.
 * Extracts and transforms event settings into typed properties.
 *
 * @param apiEvent - The raw API event object to convert
 * @returns The transformed Event object with parsed settings and default values
 */
export const convertApiEvent = (apiEvent: ApiEvent): Event => {
  const apiEventSettings = apiEvent.settings ?? [];

  delete apiEvent.settings;

  const event: Event = { ...apiEvent };

  event.isEventLive = isEventSettingTrue(apiEventSettings, 'isEventLive');

  event.showCountdown = isEventSettingTrue(apiEventSettings, 'isShowCountdown');

  event.showParticipants = isEventSettingTrue(
    apiEventSettings,
    'isParticipantDataAvailable',
  );

  const appNotes = getEventSettingValue(apiEventSettings, 'appNotes');
  event.cards = appNotes ? (JSON.parse(appNotes) as CardConfig[]) : [];

  event.startTime = getEventSettingValue(apiEventSettings, 'startTime');

  const actions = getEventSettingValue(apiEventSettings, 'actions');
  event.actions = actions ? (JSON.parse(actions) as EventAction[]) : [];

  return event;
};
